import React, { useState } from "react";
import * as Type from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import { BnbLabel, useBnbOptionalLabel } from "../../../../utils/labels";
import Popover from "../../../../../../../common-deprecated/components/popover/aem/Popover";
import * as Button from "../../../../../../../common-deprecated/styles/v2/toyota/components/Button";
import { useBnbSelector } from "../../../../redux/store";
import * as Flex from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import * as PacksView from "./styles/Packs";
import Pack from "./Pack";
import { ToggleIconWrapper } from "../../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import Icon from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { trackExtrasShow } from "../../../../utils/tracking";
import { NavStep } from "../../../../../shared-logic/utils/Navigation";
import type { ExtraType } from "../../../../../../../common-deprecated/types/CommonTypes";
import CarDataConsolidator from "../../../../../../shared-logic/utils/classes/CarDataConsolidator";

type PropsType = {
    extra?: ExtraType; // When provided only packs are shown which include this extra. The header is also hidden
};
const Packs = (props: PropsType): JSX.Element | null => {
    const { extra } = props;

    const wltpPopupText = useBnbOptionalLabel("T1.disclaimerWltpShort");
    const items = useBnbSelector((state) => state.items);

    const packsDisclaimerText = useBnbOptionalLabel("packsRecommendedDisclaimer");

    const packs = extra ? CarDataConsolidator.findPackEquipment(extra, items.packs)?.packs || [] : items.packs;

    const [showAllPacks, setShowAllPacks] = useState<boolean>(false);
    const maxPacks = 3;

    if (packs.length < 1) return null;

    return (
        <>
            {!extra && (
                <PacksView.Header mb={4}>
                    <Flex.Col>
                        <Type.H2 headingType="gamma" mb={0}>
                            <BnbLabel label="packsRecommended" />
                            {!!wltpPopupText && <Popover showOnClick content={wltpPopupText} useHTML />}
                        </Type.H2>
                        {!!packsDisclaimerText && (
                            <PacksView.Description mt={2}>{packsDisclaimerText}</PacksView.Description>
                        )}
                    </Flex.Col>
                </PacksView.Header>
            )}
            {packs.slice(0, showAllPacks ? packs.length : maxPacks).map((pack, index) => (
                <Pack packIndex={index} pack={pack} key={pack.id} showImage={index < 3} />
            ))}

            {!showAllPacks && packs.length > maxPacks && (
                <Flex.Row my={4}>
                    <Flex.Col width={1} display="flex" justifyContent="center">
                        <Button.Link
                            hasIcon
                            hasIconRight
                            large
                            width={{ _: "100%", md: "auto" }}
                            onClick={() => {
                                setShowAllPacks(true);
                                trackExtrasShow(NavStep.Customize, "show-all-extra-packs");
                            }}
                        >
                            <BnbLabel label="showAllPacks" />
                            <ToggleIconWrapper isDown={false}>
                                <Icon variant="chevronDown" />
                            </ToggleIconWrapper>
                        </Button.Link>
                    </Flex.Col>
                </Flex.Row>
            )}
        </>
    );
};

export default Packs;
